import HttpService from '@/services/http/http.service';

export default class StudentService {
	constructor() {
		this.http = new HttpService();
	}

	privateKey() {
		return this.http.get('student/private-key');
	}

	machines() {
		return this.http.get('student/machines');
	}

	machine(machineId) {
		return this.http.get(`student/machine/${machineId}`);
	}
}
